import modelBaseV2 from "../model-base-v2.model"

const POSMGoodsApproval = {
  getGoodsApprovalList: (body) => {
    return modelBaseV2.post('/api/posmGoodsIssueApproval/list', { body })
  },
  saveGoodsApproval: (body) => {
    return modelBaseV2.post('/api/posmGoodsIssueApproval/save', { body })
  },
  saveMultipleGoodsApproval: (body) => {
    return modelBaseV2.post('/api/posmGoodsIssueApproval/saveMultiple', { body })
  },
  downloadExcelGoodsApproval: (params, filename) => {
    let requestConfig = [
      { code: "138", value: params.dateFrom },
      { code: "139", value: params.dateTo },
      { code: "151", value: params.mainId?.toString() || '' },
      { code: "142", value: params.goodsTypeId?.toString() || '' },
      { code: "141", value: params.divisionId?.toString() || '' },
      { code: "140", value: params.modelId?.toString() || '' },
      { code: "137", value: params.basicModelId?.toString() || '' },
      { code: "143", value: params.warehouseId?.toString() || '' },
      { code: "144", value: params.storageId?.toString() || '' },
      { code: "149", value: params.channelCodes },
      { code: "32", value: params.userIDs },
      { code: "146", value: params.approvalStatusCode },
      { code: "150", value: params.isConfirm === null ? '' : params.isConfirm ? '1' : '0' },
      { code: "3", value: "1" },
      { code: "4", value: "-1" },
      { code: "2", value: "" },
      { code: "24", value: "" },
    ]
    const exportConfig = {
      excelSheetNames: ["List"],
      storedProcedureCode: "72",
      params: requestConfig
    }

    return modelBaseV2.postDownload('/api/survey/export/tr/file', { body: exportConfig }, filename)
  },
}

export const { getGoodsApprovalList, saveGoodsApproval, saveMultipleGoodsApproval, downloadExcelGoodsApproval } = POSMGoodsApproval;